import { MapPinLocationControl } from '@components/Map/MapPinLocationControl';
import { MapPinSelectionDialog } from '@components/Map/MapPinSelectionDialog';
import { useBookingActions, useBookingAddress, useBookingPinLocation } from 'noddi-web';
import { useState } from 'react';

export const MapPinSelectionBookingStore = () => {
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const { setPinLocation } = useBookingActions();
  const pinLocation = useBookingPinLocation();
  const selectedAddress = useBookingAddress();

  const initialLocationLatitude = pinLocation?.lat ?? selectedAddress?.latitude;
  const initialLocationLongitude = pinLocation?.lng ?? selectedAddress?.longitude;

  return (
    <>
      <MapPinLocationControl pinLocation={pinLocation} onOpenPicker={() => setIsPickerOpen(true)} />
      <MapPinSelectionDialog
        isOpen={isPickerOpen}
        initialLatitude={initialLocationLatitude}
        initialLongitude={initialLocationLongitude}
        addressLatitude={selectedAddress?.latitude}
        addressLongitude={selectedAddress?.longitude}
        onLocationSelected={(lat, lng) => {
          setPinLocation({ lat, lng });
          setIsPickerOpen(false);
        }}
        onClose={() => setIsPickerOpen(false)}
      />
    </>
  );
};
